import { valueFormatter } from "components/widgets/chart/insBubbleChart/helpers";
const getDatapointValue = (total, name) => total.datapoints?.find((dp) => dp.name === name)?.value;
const sortByXaxis = (data, xaxis) => {
    if (!xaxis?.length) {
        return data;
    }
    return [...data].sort((a, b) => {
        const aIndex = xaxis.indexOf(a.name);
        const bIndex = xaxis.indexOf(b.name);
        return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
    });
};
export const addTotalSeriesVisitor = (params) => (args) => {
    const { totals, customResult } = args.context.staticData;
    const xaxis = args.context.staticData.root?.[0]?.additionalData?.xaxis;
    params?.forEach((totalParam) => {
        const { xDatapoint, yDatapoint, name: seriesName, type, yAxis, valueFormat } = totalParam;
        const totalData = totals?.map((total) => {
            const name = getDatapointValue(total, xDatapoint);
            const value = getDatapointValue(total, yDatapoint);
            const y = isNaN(value) ? value?.amount : value;
            return name && y
                ? { custom: { tooltip: [[name, valueFormatter(y, valueFormat, value.currency)]] },
                    name,
                    y }
                : {};
        }).filter((dp) => Object.keys(dp).length);
        const hasTotalSeries = customResult?.some((series) => series.metaData?.isTotalSeries && series.name === seriesName);
        const sortedData = totalData?.length ? sortByXaxis(totalData, xaxis) : totalData;
        sortedData?.length && !hasTotalSeries && customResult?.push({
            colorIndex: totalParam.colorIndex,
            data: sortedData,
            metaData: { isTotalSeries: true },
            name: seriesName,
            type,
            yAxis,
            ...totalParam.marker ? { marker: totalParam.marker } : {}
        });
    });
};
